const state = () => {
  return {
    persons: [],
    person_filters: {},
  }
}

export default state;
